import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=6774359a&"
import script from "./Checkbox.vue?vue&type=script&lang=ts&"
export * from "./Checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6774359a')) {
      api.createRecord('6774359a', component.options)
    } else {
      api.reload('6774359a', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=6774359a&", function () {
      api.rerender('6774359a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/Checkbox.vue"
export default component.exports